import { DataMapDto } from "../../server/dto/datamap/DataMapDto";
import {
  DataMapCollectionUpdateOperation,
  DataMapDisclosureUpdateOperation,
  DataMapOperation,
} from "../../server/dto/datamap/DataMapRequestDto";

export const addPendingOperations = (operations: DataMapOperation[], dataMap: DataMapDto) => {
  // remove any pending duplicate operations, before adding our operations in
  removePendingOperations(operations, dataMap);

  const newOperations = dataMap?._local?.operations ?? [];

  newOperations.push(...operations);

  dataMap._local = dataMap._local ?? {};
  dataMap._local.operations = newOperations;
};

export const removePendingOperations = (operations: DataMapOperation[], dataMap: DataMapDto) => {
  const newOperations = dataMap?._local?.operations ?? [];
  operations.forEach((op) => {
    const idx = newOperations.findIndex(
      (newOp) =>
        newOp.target == op.target &&
        newOp.groupId == op.groupId &&
        (newOp as DataMapCollectionUpdateOperation).picId ==
          (op as DataMapCollectionUpdateOperation).picId &&
        (newOp as DataMapDisclosureUpdateOperation).vendorId ==
          (op as DataMapDisclosureUpdateOperation).vendorId &&
        (newOp as DataMapDisclosureUpdateOperation).picGroupId ==
          (op as DataMapDisclosureUpdateOperation).picGroupId,
    );

    if (idx >= 0) {
      newOperations.splice(idx, 1);
    }
  });

  dataMap._local = dataMap._local ?? {};
  dataMap._local.operations = newOperations;
};
